import SocketIO from '@/utils/socket'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import Vue from 'vue'
import { notification } from 'ant-design-vue/es'
import rootStore from '@/store'
const downloadSocktConfig = {
  namespaced: true,
  state: {
    socket: null,
    guide: null,
    fileUrl: '',
    fileName: '',
    heartBeatTimer: '',
    heartBeatInterval: 1000 * 60
  },
  mutations: {
    SET_FILEURL (state, data) {
      state.fileUrl = data
    },
    SET_FILENAME (state, data) {
      state.fileName = data
    },
    SET_SOCKET (state, data) {
      state.socket = data
      },
    SET_BEAT_TIMER (state, data) {
      state.heartBeatTimer = data
    }
  },
    actions: {
        initWS ({ state, commit, dispatch }) {
            state.socket && state.socket.close()
            if (Vue.ls.get(ACCESS_TOKEN)) {
                // dispatch('downloadWarn')
                // dispatch('downloadSuccess')
                commit('SET_SOCKET', new SocketIO(process.env.VUE_APP_SOCKET_DOWNLOAD))
                state.socket.on('open', (data) => {
                    // 连接成功时启动定时发送心跳消息，避免被服务器断开连接
                    window.clearInterval(state.heartBeatTimer)
                    commit('SET_BEAT_TIMER', 0)
                    commit('SET_BEAT_TIMER', window.setInterval(() => {
                        const message = '心跳消息'
                        state.socket.send(
                            {
                                code: 200,
                                msg: message,
                                company: JSON.parse(localStorage.getItem('pro__uesr_info')).value?.subjectCodeEncrypt,
                                authorization: Vue.ls.get(ACCESS_TOKEN)
                            }
                        )
                    }, state.heartBeatInterval))
                })

                state.socket.on('message', (event) => {
                    dispatch('messagePush', event.data)
                })
                state.socket.on('close', () => {
                    setTimeout(() => {
                        dispatch('initWS')
                    }, 5000)
                })
            }
        },
        messagePush ({ state, commit, dispatch }, data) {
            if (data && typeof data === 'string') {
                const result = JSON.parse(data)
                // result.data?.uniqueId区分是否为下载相关的消息
                if (result.data?.uniqueId) {
                    commit('SET_FILENAME', result.data?.name || '')
                    if (`${result.code}` === '0') {
                        // dispatch('prepareIng')
                        if (result?.data?.fileOssUrl) {
                            commit('SET_FILEURL', result?.data?.fileOssUrl)
                            dispatch('downloadSuccess')
                        }
                    } else {
                        dispatch('downloadError', result?.message)
                    }
                }
            }
        },
        // 立即下载
        downloadUrl ({ state, commit }, url) {
            const alink = document.createElement('a')
            alink.style.display = 'none'
            alink.download = '下载列表'
            alink.href = url || ''
            document.body.appendChild(alink)
            alink.click()
            document.body.removeChild(alink)
            Vue.$message.success('下载成功！')
        },
        goToDownloadPage ({ state, dispatch, rootState }) {
            const {
                entry: { serviceId, systemCode }
            } = rootState
            rootStore.dispatch('entry/SetActiveAsync', {
                ignore: true,
                menuName: {
                    zh_CN: '导出中心',
                    en_US: 'Export Center'
                },
                path: `/entry/${serviceId}/${systemCode}/universal_system#/download-center`
            })
            notification.destroy()
        },
        // 下载文件准备中
        prepareIng ({ dispatch }) {
            return Vue.prototype.$notification.info({
                message: (h) => h('div', { style: { fontWeight: 'bold', fontSize: '14px' } }, '下载文件准备中'),
                duration: null,
                key: 'prepare',
                icon: h => h('a-icon', { props: { type: 'loading' }, style: { color: '#1e5af9' } }),
                description: h => h('div',
                    {
                        props: { type: 'loading' },
                        style: { fontSize: '12px', color: '#4E535C' }
                    }, ['准备工作会在后台进行，你可以选择进行其他操作或稍后前往', h(
                        'a', {
                         on: { click: () => dispatch('goToDownloadPage') },
                        style: { color: '#1e5af9' }
                    }, '导出中心'
                    )
                ])

            })
        },
        // 下载完成
        downloadSuccess ({ state, dispatch }) {
           notification.destroy()
           return Vue.prototype.$notification.open({
                message: (h) => h('div', { style: { fontWeight: 'bold', fontSize: '14px' } }, '文件下载完成'),
                duration: null,
                key: 'success',
                icon: h => h('a-icon', { props: { type: 'check-circle', theme: 'filled' }, style: { color: '#28A864' } }),
               btn: h => h('a-button', {
                   props: { type: 'primary' },
                   on: { click: () => dispatch('downloadUrl', state.fileUrl) },
                   style: {
                       color: '#fff',
                       padding: '4px 8px',
                       fontSize: '12px',
                       borderRadius: '4px'
                     } }, '立即下载'),
                   description: h => h('div',
                    {
                        style: { fontSize: '12px', color: '#4E535C' }
                    }, [`【${state.fileName}】已生成， 你可以选择“立即下载”或稍后在`, h(
                        'a', {
                        on: { click: () => dispatch('goToDownloadPage') },
                        style: { color: '#1e5af9' }
                       }, '导出中心'
                     ), '查看'
                ])

            })
       },

    // 下载出错
    downloadError ({ state, commit, dispatch }, msg) {
        notification.destroy()
        return Vue.prototype.$notification.open({
            message: (h) => h('div', { style: { fontWeight: 'bold', fontSize: '14px' } }, '导出文件失败'),
            duration: null,
            key: 'error',
            icon: h => h('a-icon', { props: { type: 'close-circle', theme: 'filled' }, style: { color: '#F5222D' } }),
            btn: h => h('a-button',
                {
                    props:
                    {
                        type: 'primary'

                    },
                    on: { click: () => dispatch('downloadUrl', state.fileUrl) },
                    style: {
                        color: '#fff',
                        padding: '4px 8px',
                        fontSize: '12px',
                        borderRadius: '4px'
                    }
                }, '重试'),
            description: (h) => h('div',
                 { style: { color: '#4E535C' } },
                `【${state.fileName}】${msg || '导出失败，你可以选择“重试”'}`)
      })
    },
    // 下载中提醒
    downloadWarn ({ dispatch }) {
      Vue.prototype.$notification.open({
        message: (h) => h('div', { style: { fontWeight: 'bold', fontSize: '14px' } }, '提示'),
        duration: null,
        key: 'error',
          icon: h => h('a-icon', { props: { type: 'close-circle', theme: 'filled' }, style: { color: '#f58717' } }),
          description: h => h('div',
                    {
                        style: { fontSize: '12px', color: '#4E535C' }
                    }, [`已有相同任务，请到`, h(
                        'a', {
                        on: { click: () => dispatch('goToDownloadPage') },
                        style: { color: '#1e5af9' }
                       }, '导出中心'
                     ), '查看'
                ])
      })
    }
    // 导出
    // handleExportData () {
      // if (props.downloadMethod) {
      //   props
      //     .downloadMethod({ ...(props.downloadParams ? props.downloadParams : {}) })
      //     .then((res) => {
      //       const { data, message: msg } = res
      //       if (msg?.includes('已有相同任务')) {
      //         downloadWarn()
      //       } else {
      //         if (data.uniqueId) {
      //           currentSocked.sendMessage(data.uniqueId)
      //         } else {
      //           downloadError()
      //         }
      //       }
      //     })
      //     .catch(() => {
      //       notification.destroy()
      //       downloadError()
      //       throw new Error('导出失败')
      //     })
    // }
  }
}
//     async mounted () {
//       console.log(this.$ls.get(ACCESS_TOKEN))
//     if (!this.$ls.get(ACCESS_TOKEN)) return
//     this.initWS()
//   },
//   beforeDestroy () {
//    state.socket &&state.socket.close()
//   }

export default downloadSocktConfig
